import sales from '@/locales/es/sales/sales.locales';

export default {
    ...sales,
};
